import { createContext, useContext, useMemo, useEffect, ReactNode } from 'react';

interface EmbedContextValue {
  isEmbedded: boolean;
}

const EmbedContext = createContext<EmbedContextValue>({
  isEmbedded: false,
});

export function useEmbed() {
  return useContext(EmbedContext);
}

interface EmbedProviderProps {
  children: ReactNode;
}

export function EmbedProvider({ children }: EmbedProviderProps) {
  const isEmbedded = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('embed') === 'true';
  }, []);

  // Apply body class for embed mode styling
  useEffect(() => {
    if (isEmbedded) {
      document.body.classList.add('embed-mode');
    } else {
      document.body.classList.remove('embed-mode');
    }

    return () => {
      document.body.classList.remove('embed-mode');
    };
  }, [isEmbedded]);

  const value = useMemo(() => ({ isEmbedded }), [isEmbedded]);

  return (
    <EmbedContext.Provider value={value}>
      {children}
    </EmbedContext.Provider>
  );
}
